import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Map } from 'leaflet'

// Components
// import SearchIcon from 'fc-icons/src/Search'
import CategorySelector from './CategorySelector'
import LocationSearch from './LocationSearch'
import LldSearch from './LldSearch'

// Constants
import { CITY, LLD, LATLON } from '../constants'

// Styles
import { grey, white } from 'hfty-styles/src/colors'

const componentStyle = {
  flex: '1 1 auto',
  display: 'flex',
  flexDirection: 'column',
  color: white(),
  fontSize: 14,
}

// Exports
export default class MapSearch extends Component {
  constructor() {
    super()

    this.state = {
      category: CITY,
    }

    this.onSelectCategory = this.onSelectCategory.bind(this)
    this.onZoomToLatLng = this.onZoomToLatLng.bind(this)
    this.onZoomToBounds = this.onZoomToBounds.bind(this)
  }

  onSelectCategory({ category }) {
    this.setState({
      category,
    })
  }

  onZoomToLatLng({ lat, lng }) {
    this.props.flyTo([lat, lng])
  }

  onZoomToBounds(bounds) {
    this.props.fitMapBounds(bounds)
  }

  render() {
    return (
      <div style={componentStyle}>
        <CategorySelector
          onSelectCategory={this.onSelectCategory}
          selected={this.state.category}
          lld={this.props.lld}
        />
        {this.state.category !== LLD ? (
          <LocationSearch
            key={this.state.category}
            onZoomToLatLng={this.onZoomToLatLng}
            onZoomToBounds={this.onZoomToBounds}
            latlng={this.state.category === LATLON}
          />
        ) : (
          <LldSearch
            key={this.state.category}
            onZoomToLatLng={this.onZoomToLatLng}
            onZoomToBounds={this.onZoomToBounds}
          />
        )}
      </div>
    )
  }
}

MapSearch.contextTypes = {
  map: PropTypes.instanceOf(Map),
}

MapSearch.propTypes = {
  flyTo: PropTypes.func.isRequired,
  fitMapBounds: PropTypes.func.isRequired,
  lld: PropTypes.bool,
}
